import React, { useEffect } from 'react';
import moment from 'moment';
import { useSelector, useDispatch } from "react-redux";
import { Col, Row, Spin, Tooltip } from "antd";
import { Area, AreaChart, ResponsiveContainer } from 'recharts';

import Widget from "../../components/Widget/index";
import { fetchGeneralTotal, fetchGeneralTotalCumulative, fetchMerchantTotal, fetchMerchantTotalCumulative } from "../../redux/actions/Aggregate";
import { generateDateTimeRange } from '../../util/lib';
import { fetchMerchantAccounts } from '../../redux/actions/Data';

const EurCard = ({ merchantId }) => {
  const dispatch = useDispatch();
  const { timezone } = useSelector(({ settings }) => settings);
  const { data: generalHourlyEur, loading: loadingGeneralHourlyEur } = useSelector(({ aggregate }) => aggregate.generalHourlyEur);
  const { data: generalEurTotal, loading: loadingGeneralEurTotal } = useSelector(({ aggregate }) => aggregate.generalEurTotal);
  const { data: merchantHourlyEur, loading: loadingMerchantHourlyEur } = useSelector(({ aggregate }) => aggregate.merchantHourlyEur);
  const { data: merchantEurTotal, loading: loadingMerchantEurTotal } = useSelector(({ aggregate }) => aggregate.merchantEurTotal);
  const { data: merchantAccounts, loading: loadingMerchants } = useSelector(({ data }) => data.merchantAccounts);

  // const eurWallet = wallets && wallets.length > 0 ? wallets.find((wallet) => wallet.currency === '') : "EUR"
  const todaysDate = moment().format('YYYY-MM-DD');
  const todaysDateWithTimezone = generateDateTimeRange(todaysDate, timezone);
  const yesterday = moment().subtract(1, 'days').format('YYYY-MM-DD');
  const yesterdayWithTimezone = generateDateTimeRange(yesterday, timezone);

  useEffect(() => {
    if (merchantId) {
      dispatch(fetchMerchantTotal(
        merchantId,
        'CARD',
        'EUR',
        'COMPLETED',
        'hour',
        "None",
        `start=${todaysDateWithTimezone.start}&end=${todaysDateWithTimezone.end}`));

      dispatch(fetchMerchantTotalCumulative(
        merchantId,
        'CARD',
        'EUR',
        'COMPLETED',
        'hour',
        'today',
        `start=${todaysDateWithTimezone.start}&end=${todaysDateWithTimezone.end}`));

      dispatch(fetchMerchantTotalCumulative(
        merchantId,
        'CARD',
        'EUR',
        'COMPLETED',
        'hour',
        'yesterday',
        `start=${yesterdayWithTimezone.start}&end=${yesterdayWithTimezone.end}`));

    } else {
      dispatch(fetchMerchantAccounts());
    }

  }, [dispatch, merchantId, timezone]);

  useEffect(() => {
    if (merchantAccounts && merchantAccounts.length > 0) {
      const merchantIds = `merchant_id={"$in": [${merchantAccounts.map((account) => `"${account._id}"`).join(',')}]}`;
      const queries = [
        merchantIds,
        `start=${moment(todaysDateWithTimezone.start).format('YYYY-MM-DD')}`,
        `end=${moment(todaysDateWithTimezone.end).format('YYYY-MM-DD')}`
      ];

      const params = queries.join('&');

      dispatch(fetchGeneralTotal(
        'CARD',
        'EUR',
        'COMPLETED',
        'hour',
        "None",
        params
      ));

      dispatch(fetchGeneralTotalCumulative(
        'CARD',
        'EUR',
        'COMPLETED',
        'hour',
        'today',
        params
      ));

      dispatch(fetchGeneralTotalCumulative(
        'CARD',
        'EUR',
        'COMPLETED',
        'hour',
        'yesterday',
        params
      ));
    }
  }, [merchantAccounts]);

  const data = merchantId ? merchantHourlyEur : generalHourlyEur;
  const loading = merchantId ? loadingMerchantHourlyEur : loadingGeneralHourlyEur;
  const total = merchantId ? merchantEurTotal : generalEurTotal;
  const totalAmountToday = total?.total_amount_today;
  const totalAmountYesterday = total?.total_amount_yesterday;

  return (
    (!loadingGeneralHourlyEur)
    && (<Widget styleName={`gx-card-full`}>
      <div className="gx-d-flex gx-px-4 gx-pt-4 gx-pb-2">
        <p className="gx-text-uppercase gx-chart-title">EUR Collections</p>
        <p className="gx-ml-auto gx-text-primary">
          {
            totalAmountToday && totalAmountYesterday && totalAmountYesterday !== 0
              ? ((totalAmountToday - totalAmountYesterday) / totalAmountYesterday * 100).toFixed(0)
              : 0
          }%
          <i className={`icon icon-menu-${totalAmountToday > totalAmountYesterday ? 'up' : "down"} gx-fs-sm`} /></p>
      </div>
      <Row>
        <Col lg={12} md={12} sm={24} xs={24}>
          <div className="gx-actchart gx-pb-5 gx-pl-4">
            <h2 className="gx-fs-xxxl gx-font-weight-medium gx-mb-1 gx-text-black">
              €{!loading ? totalAmountToday : (<Spin className="gx-text-center" />)}
            </h2>
            <p className="gx-mb-0">Today</p>
          </div>
        </Col>
        <Col lg={12} md={12} sm={24} xs={24}>
          <ResponsiveContainer width="100%" height={50}>
            <AreaChart data={data}
              margin={{ top: 0, right: 0, left: 0, bottom: 0 }}>
              <Tooltip />
              <defs>
                <linearGradient id="color1" x1="0" y1="0" x2="1" y2="0">
                  <stop offset="5%" stopColor="#23DFDC" stopOpacity={0.9} />
                  <stop offset="95%" stopColor="#63AEE4" stopOpacity={0.9} />
                </linearGradient>
              </defs>
              <Area dataKey="total_amount" strokeWidth={0} stackId="2" stroke='#867AE5' fill="url(#color1)" fillOpacity={1} />
            </AreaChart>
          </ResponsiveContainer>
        </Col>
      </Row>
    </Widget>)
  )
};

export default EurCard;
